import { Analyzer, Dish, Location, Satellite, Switch } from 'types';
import { useDeleteAnalyzer } from '../../analyzers/api/deleteAnalyzer';
import { useDeleteDish } from '../../dishes/api/deleteDish';
import { useDeleteLocation } from '../../locations/api/deleteLocation';
import { useDeleteSatellite } from '../../satellites/api/deleteSatellite';
import { useDeleteSwitch } from '../../switches/api/deleteSwitch';

export const useNodeDeleteHandler = (
  dish: Dish | undefined,
  analyzer: Analyzer | undefined,
  selectedSwitch: Switch | undefined,
  selectedLocation: Location | undefined,
  satellite: Satellite | undefined
) => {
  const deleteDish = useDeleteDish({});
  const deleteAnalyzer = useDeleteAnalyzer({});
  const deleteSwitch = useDeleteSwitch({});
  const deleteLocation = useDeleteLocation({});
  const deleteSatellite = useDeleteSatellite({});
  const handleDeleteNode = () => {
    if (dish) {
      deleteDish.mutateAsync(dish.id);
      return;
    }
    if (analyzer) {
      deleteAnalyzer.mutateAsync(analyzer.id);
      return;
    }
    if (selectedSwitch) {
      deleteSwitch.mutateAsync(selectedSwitch.id);
      return;
    }
    if (selectedLocation) {
      deleteLocation.mutateAsync(selectedLocation.id);
      return;
    }
    if (satellite) {
      deleteSatellite.mutateAsync(satellite.id);
      return;
    }
  };
  return handleDeleteNode;
};
